import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  HostListener
} from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import {
  NbSidebarService,
  NbIconLibraries,
  NbSearchService,
  NbMenuService,
  NbIconConfig,
  NbMenuItem,
  NbDialogService
} from "@nebular/theme";
import { Router, NavigationEnd } from "@angular/router";
import { AuthService } from "../../services/auth.service";
import { UserService } from "../../services/user.service";
import { CurrentUserService } from "src/app/services/current-user.service";
import { Subscription } from "rxjs";
import { ModalProfileComponent } from "src/app/pages/profile/modal-profile.component";
import { FavoriteService } from "src/app/services/favorite.service";
import { FavoriteGET } from "src/app/models/Favorite";
import { sortBy } from "lodash";
import { AlertService } from "src/app/services/alert.service";

@Component({
  selector: "app-topbar",
  templateUrl: "./topbar.component.html",
  styleUrls: ["./topbar.component.scss"]
})
export class TopbarComponent implements OnInit, OnDestroy {
  @Input()
  showNotificationButton = false;
  @Input() onLandingPage = false;
  @Input()
  showMessageButton = false;
  user = {
    menu: [{ title: "Meus dados" }, { title: "Sair" }],
    nome: "",
    login: "",
    urlImagem:
      "data:image/png;base64,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"
  };
  routerLogo: string;
  windowWidth: number = window.innerWidth;
  disabledIconConfig: NbIconConfig = {
    icon: "settings-2-outline",
    pack: "eva"
  };

  selectedItem: string;
  items: NbMenuItem[];
  itemsResponsiveToBackoffice: NbMenuItem[];
  subscriptions = new Subscription();
  showTopBar = true;
  favoritedPages = [] as FavoriteGET[];
  favoritedChildrens: NbMenuItem[];
  person: any;
  _tipoUsuario: string = "1"; //iniciando como cliente

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private iconLibraries: NbIconLibraries,
    private sidebarService: NbSidebarService,
    private router: Router,
    private menuService: NbMenuService,
    private authService: AuthService,
    private userService: UserService,
    private currentUserService: CurrentUserService,
    private dialogService: NbDialogService,
    private alert: AlertService
  ) {}

  ngOnInit() {
    this.controlNavigation();
    this.getAndConfigMenus();
    this.fetchUser();
    const personOnStorage = localStorage.getItem("person");
    this.person = personOnStorage ? JSON.parse(atob(personOnStorage)) : null;
    this._tipoUsuario = this.person ? this.person.value.tipoUsuario : "1";

    this.setRegisterMenu();
    this.handleResponsiveMenuOnBackoffice();
    const permissions = this.currentUserService.getPermissionsFromStorage();
  }

  handleResponsiveMenuOnBackoffice() {
    this.itemsResponsiveToBackoffice = [...this.items];
  }

  controlNavigation() {
    this.subscriptions.add(
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          //this.showTopBar = event.urlAfterRedirects !== '/login';
          this.redirectIfNeeded(event.urlAfterRedirects);
        }
      })
    );
  }

  redirectIfNeeded(currentPath: string) {
    const isLogged =
      !!sessionStorage.getItem("access-token") ||
      !!localStorage.getItem("refresh-token");
    if (isLogged && currentPath === "/login") {
      this.router.navigate(["/security/user"]);
    }
    if (!isLogged && currentPath !== "/login") {
      this.router.navigate(["/login"]);
    }
  }

  getAndConfigMenus() {
    this.subscriptions.add(
      this.menuService.onItemClick().subscribe(({ item }) => {
        this.resetSelectedItem(item.link);
        this.onItemSelection(item);
      })
    );
  }

  toggle() {
    this.sidebarService.toggle(true);
  }

  onItemSelection({ title }) {
    if (title === "Sair") {
      this.logout();
    } else if (title === "Meus dados") {
      this.profile();
    }
  }

  logout() {
    this.alert.success("Você será redirecionado a tela de login");
    // this.showTopBar = false;
    this.authService.logout();
  }

  profile() {
    this.dialogService.open(ModalProfileComponent);
  }

  fetchUser() {
    const { id } = this.authService.decode();
    if (id) {
      this.subscriptions.add(
        this.userService.fetchUserById(id).subscribe(response => {
          const value = response.value;
          value.tipoUsuario === 0
            ? (this.routerLogo = "/companies-report")
            : (this.routerLogo = "/security/user");

          const usuario = (this.user = { ...this.user, ...value });

          if (!this.user.urlImagem) {
            usuario.urlImagem =
              "data:image/png;base64,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";
          }

          return usuario;
        })
      );
    }
  }

  redirecionaLogin() {
    this.router.navigate(["/security/user"]);
  }

  resetSelectedItem(route: string) {
    if (this.items) {
      this.items.forEach(item => {
        const { children } = item;
        if (children) {
          children.forEach((child: any) => {
            child.selected = route === child.link ? true : false;
          });
        }
      });
    }
  }

  setRegisterMenu() {
    this.items = this.getRegisterMenu();
  }

  getRegisterMenu(): NbMenuItem[] {
    let menu: NbMenuItem[] = [];

    if (localStorage.getItem("moduloSelecionado") === null) {
      localStorage.setItem("moduloSelecionado", "Gestão da Plataforma");
    }

    const permissions = this.currentUserService.getPermissionsFromStorage();

    let showParentDashboard = true;
    if (showParentDashboard) {
      menu.push({
        title: "Home",
        icon: "dashboard",
        link: "dashboard"
      });
    }

    // estação
    let showParentEstacao = false;
    if (parseInt(this._tipoUsuario) === 0) {
      showParentEstacao = permissions.some(
        e => e.nome === this.currentUserService.getEnumPermissions().AtualizarEstacao ||
          e.nome === this.currentUserService.getEnumPermissions().CadastrarEstacao ||
          e.nome === this.currentUserService.getEnumPermissions().ConsultarEstacao ||
          e.nome === this.currentUserService.getEnumPermissions().DeletarEstacao ||
          e.nome === this.currentUserService.getEnumPermissions().ConfigurarEstacao ||
          e.nome === this.currentUserService.getEnumPermissions().ConfigurarWebServicePesquisar ||
          e.nome === this.currentUserService.getEnumPermissions().HistoricoDeDadosPesquisar ||
          e.nome === this.currentUserService.getEnumPermissions().ConfigurarParametroPesquisar
      );
    }

    if (showParentEstacao) {
      menu.push({
        title: "Estação",
        icon: "pin_drop",
        children: [
          {
            title: "Visualizar Estações",
            link: "estacao",
            selected: false,
            hidden: !permissions.some(
              e =>
                e.nome ===
                this.currentUserService.getEnumPermissions().ConsultarEstacao
            )
          },
          {
            title: "Configurar Parâmetros",
            link: "/estacao/parametro",
            selected: false,
            hidden: !permissions.some(
              e =>
                e.nome ===
                this.currentUserService.getEnumPermissions().ConfigurarParametroPesquisar
            )
          },
          {
            title: "Configurar Categorias",
            link: "/estacao/categorias",
            selected: false,
            hidden: !permissions.some(
              e =>
                e.nome ===
                this.currentUserService.getEnumPermissions().ConfigurarParametroPesquisar
            )
          },
          {
            title: "Histórico de Dados",
            link: "/estacao/historico",
            selected: false,
            hidden: !permissions.some(
              e => e.nome === this.currentUserService.getEnumPermissions().HistoricoDeDadosPesquisar
            )
          },
          {
            title: "Configurar Web Service",
            link: "/estacao/webservice",
            selected: false,
            hidden: !permissions.some(
              e => e.nome === this.currentUserService.getEnumPermissions().ConfigurarWebServicePesquisar
            )
          },
          {
            title: "Configurar Link",
            link: "/estacao/link",
            selected: false,
            hidden: !permissions.some(
              e => e.nome === this.currentUserService.getEnumPermissions().ConfigurarWebServicePesquisar
            )
          }
        ]
      });
    }

    //antenas
    let showParentAntenas = false;
    if (parseInt(this._tipoUsuario) === 1)
      //se for cliente, mostra as antenas
      showParentAntenas = true;

    if (showParentAntenas) {
      menu.push({
        title: "Antenas",
        icon: "how_to_reg",
        children: [
          {
            title: "Consultar Antenas",
            link: "antenas"
          }
        ]
      });
    }

    //cadastros
    let showParentCadastros = false;
    if (parseInt(this._tipoUsuario) === 0) {
      //se for admin
      showParentCadastros = permissions.some(
        e =>
          e.nome === this.currentUserService.getEnumPermissions().AtualizarCliente ||
          e.nome === this.currentUserService.getEnumPermissions().CadastrarCliente ||
          e.nome === this.currentUserService.getEnumPermissions().ConsultarCliente ||
          e.nome === this.currentUserService.getEnumPermissions().DeletarCliente ||
          e.nome === this.currentUserService.getEnumPermissions().AtualizarBoia ||
          e.nome === this.currentUserService.getEnumPermissions().CadastrarBoia ||
          e.nome === this.currentUserService.getEnumPermissions().ConsultarBoia ||
          e.nome === this.currentUserService.getEnumPermissions().DeletarBoia
      );
    }
    // cadastro
    if (showParentCadastros) {
      menu.push({
        title: "Empresas",
        icon: "person",
        link: "clientes",
        selected: false,
        expanded: false,
        group: false,
        hidden: !permissions.some(
          e =>
            e.nome ===
            this.currentUserService.getEnumPermissions().ConsultarCliente
        )
      });
    }

    //segurança
    let showParentSeguranca = false;
    if (parseInt(this._tipoUsuario) === 0) {
      //se for admin
      showParentSeguranca = permissions.some(
        e =>
          e.nome === this.currentUserService.getEnumPermissions().ConsultarUsuario ||
          e.nome === this.currentUserService.getEnumPermissions().CadastrarUsuario ||
          e.nome === this.currentUserService.getEnumPermissions().AtualizarUsuario ||
          e.nome === this.currentUserService.getEnumPermissions().DeletarUsuario ||
          e.nome === this.currentUserService.getEnumPermissions().ConsultarGrupo ||
          e.nome === this.currentUserService.getEnumPermissions().CadastrarGrupo ||
          e.nome === this.currentUserService.getEnumPermissions().AtualizarGrupo ||
          e.nome === this.currentUserService.getEnumPermissions().DeletarGrupo ||
          e.nome === this.currentUserService.getEnumPermissions().ConsultarPermissoesGrupo ||
          e.nome === this.currentUserService.getEnumPermissions().CadastrarPermissaoGrupo ||
          e.nome === this.currentUserService.getEnumPermissions().DeletarPermissaoGrupo
      );
    }

    if (showParentSeguranca) {
      menu.push({
        title: "Segurança",
        icon: "fingerprint",
        children: sortBy(
          [
            {
              title: "Usuários",
              link: "security/user",
              selected: false,
              hidden: !permissions.some(
                e =>
                  e.nome === this.currentUserService.getEnumPermissions().ConsultarUsuario ||
                  e.nome === this.currentUserService.getEnumPermissions().CadastrarUsuario ||
                  e.nome === this.currentUserService.getEnumPermissions().AtualizarUsuario ||
                  e.nome === this.currentUserService.getEnumPermissions().DeletarUsuario)
            },
            {
              title: "Perfis de Permissões",
              link: "security/group",
              selected: false,
              hidden: !permissions.some(
                e =>
                  e.nome === this.currentUserService.getEnumPermissions().ConsultarGrupo ||
                  e.nome === this.currentUserService.getEnumPermissions().CadastrarGrupo ||
                  e.nome === this.currentUserService.getEnumPermissions().AtualizarGrupo ||
                  e.nome === this.currentUserService.getEnumPermissions().DeletarGrupo
              )
            },
            {
              title: "Vincular Permissões",
              link: "security/group-permission",
              selected: false,
              hidden: !permissions.some(
                e =>
                  e.nome === this.currentUserService.getEnumPermissions().ConsultarPermissoesGrupo ||
                  e.nome === this.currentUserService.getEnumPermissions().CadastrarPermissaoGrupo ||
                  e.nome === this.currentUserService.getEnumPermissions().DeletarPermissaoGrupo
              )
            },
            {
              title: "Termos de Uso",
              link: "security/termo-uso"
            }
          ],
          item => item.title
        )
      });
    }

    return menu;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.windowWidth = event.target.innerWidth;
  }
}
